import validatorFactory from './validatorFactory';

const ValidatorFactory = new validatorFactory();

export const validate = {
	VIN: ValidatorFactory.create('VIN'),
};